<fieldset ngModelGroup="reference{{index}}" class="referenceForm">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireName" for="referenceName{{index}}">Name of Reference</label>
        <input #referenceName="ngModel" id="referenceName{{index}}" name="referenceName" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showName" [required]="configuration.requireName"
               class="form-control" [(ngModel)]="reference.name" />
        <mdb-error *ngIf="referenceName.invalid && (referenceName.dirty || referenceName.touched)">Name is required.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireCompany" for="company{{index}}">Company</label>
        <input #company="ngModel" id="company{{index}}" name="company" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showCompany" [required]="configuration.requireCompany"
               class="form-control" [(ngModel)]="reference.company" />

        <mdb-error *ngIf="company.invalid && (company.dirty || company.touched)">Company is required.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireTitle" for="title{{index}}">Job Title</label>
        <input #title="ngModel" id="title{{index}}" name="title" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showTitle" [required]="configuration.requireTitle"
               class="form-control" [(ngModel)]="reference.title" />
        <mdb-error *ngIf="title.invalid && (title.dirty || title.touched)">Job Title is required.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireEmail" for="emailAddress{{index}}">Email Address</label>
        <input #emailAddress="ngModel" id="emailAddress{{index}}" name="emailAddress" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showEmail" [required]="configuration.requireEmail"
               class="form-control" [(ngModel)]="reference.email" />
        <mdb-error *ngIf="title.invalid && (title.dirty || title.touched)">Email is required.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requirePhone">Phone Number</label>
        <input #phoneNumber="ngModel" id="phoneNumber{{index}}" name="phoneNumber" mdbInput mdbValidate type="tel" 
               [disabled]="!configuration.showPhone" [required]="configuration.requirePhone" minlength="10" [textMask]="{mask: phoneMask}"
               class="form-control" [(ngModel)]="reference.phone" (ngModelChange)="reference.phone = unmaskPhoneNumber($event)" />
        <mdb-error *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)">Phone Number is required in the form XXX-XXX-XXXX.</mdb-error>
      </div>
    </div>
  </div>
</fieldset>
